var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 8.5C6.70914 8.5 8.5 6.70914 8.5 4.5C8.5 2.29086 6.70914 0.5 4.5 0.5C2.29086 0.5 0.5 2.29086 0.5 4.5C0.5 6.70914 2.29086 8.5 4.5 8.5Z",
    fill: "var(--fill-0, #F2F2F2)",
    stroke: "var(--stroke-0, #101820)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.5 6.1V4.5",
    stroke: "var(--stroke-0, #101820)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.5 2.9H4.505",
    stroke: "var(--stroke-0, #101820)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.fc94ab2f9e5dbdfe08d14de84ce0e1b6.svg";
export { ForwardRef as ReactComponent };